var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container has-background-white-ter is-fullheight"},[_c('div',{staticClass:"notification has-background-white has-text-centered"},[_c('h1',{staticClass:"title"},[_vm._v("Login")]),_c('br'),_c('p',[_vm._v(" Login to manage your school account ")]),_c('br'),_c('div',{attrs:{"id":"firebaseui-auth-container"}})])])
}]

export { render, staticRenderFns }